import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'

import Mask from 'generics/Mask'

import styles from './ModalUpgradeProFallback.scss'

/**
 * Shown while the lazy ModalUpgradePro chunk loads (same overlay + spinner as other modals).
 */
const ModalUpgradeProFallback = () => (
  <Mask
    className={styles.fallback}
    fixed
    open
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading upgrade modal"
  >
    <CircularProgress className={styles.spinner} size={60} thickness={7} />
  </Mask>
)

export default ModalUpgradeProFallback
